<script setup lang="ts">
import { Device } from '@/device';
import { DeviceType, GetDeviceType } from '@/helpers/device-identifier';

const props = defineProps<{ device: Device }>();

const getheadsetImageUrl = () => {
  const deviceType = GetDeviceType(props.device);
  switch (deviceType) {
    case DeviceType.NEO3EYE:
    case DeviceType.NEO3:
      return new URL(`../assets/headsets/pico-neo-3.png`, import.meta.url).href;
    case DeviceType.G3:
      return new URL(`../assets/headsets/pico-g3.png`, import.meta.url).href;
    case DeviceType.G2:
      return new URL(`../assets/headsets/pico-g2-4k.png`, import.meta.url).href;
    default:
      return new URL(`../assets/headsets/unknown.png`, import.meta.url).href;
  }
};
</script>

<template>
  <div class="card bg-primary mb-3" style="width: 18rem">
    <img :src="getheadsetImageUrl()" class="card-img-top" />
    <div class="card-body d-flex flex-column">
      <h5 class="card-title">{{ device.getDeviceProductName() }} ({{ device.getDeviceProductId() }})</h5>
      <p class="card-text">
        <b>Fabricant :</b> {{ device.getDeviceManufacturerName() }} ({{ device.getDeviceVendorId() }})<br />
        <b>Version matériel :</b> {{ device.getDeviceVersionMajor() }}.{{ device.getDeviceVersionMinor() }}.{{
          device.getDeviceVersionSubMinor()
        }}<br />
        <b>Serial :</b> {{ device.getDeviceSerialId() }}
      </p>
    </div>
  </div>
</template>

<style scoped>
.console {
  background-color: black;
}
</style>
